// extracted by mini-css-extract-plugin
module.exports = {"show-xs":"index_show-xs_2ZTjy","hide-xs":"index_hide-xs_1pEDn","description":"index_description_23iGa","item":"index_item_2ClJE","itemLabel":"index_itemLabel_1Leij"};